import { Map, Record } from "immutable";
import { vm } from "../socket/config.js";
import { nameToTarget, setLocalFlag } from "../utils/scratch-helpers.js";
import { isLocalMode } from "./local-mode.js";
import { isPauseEventHandling, setPauseEventHandling } from "./overrides.js";

const MonitorRecord = Record({
    id: null,
    spriteName: null,
    targetId: null,
    opcode: null,
    value: null,
    params: null,
    mode: "default",
    sliderMin: 0,
    sliderMax: 100,
    isDiscrete: true,
    x: null,
    y: null,
    width: 0,
    height: 0,
    visible: true,
});

export const onSpriteEditorStateChange = (data) => {
    if (isLocalMode()) return;

    const {
        target: targetName,
        x,
        y,
        direction,
        size,
        visible,
        rotationStyle,
        draggable,
    } = data.data;
    const target = nameToTarget(targetName);
    if (!target) return;

    if (x !== undefined) target.x = x;
    if (y !== undefined) target.y = y;
    if (direction !== undefined) target.direction = direction;
    if (size !== undefined) target.size = size;
    if (visible !== undefined) target.visible = visible;
    if (rotationStyle !== undefined) target.rotationStyle = rotationStyle;
    if (draggable !== undefined) target.draggable = draggable;

    if (target.renderer) {
        target.updateAllDrawableProperties();
    }
};

export const onExtensionAdded = async (data) => {
    const { extensionURL } = data.data;
    if (vm.extensionManager.isExtensionLoaded(extensionURL)) return;

    setLocalFlag(true);
    await vm.extensionManager.loadExtensionURL(extensionURL);
};

export const onMonitorAdded = (data) => {
    setLocalFlag(true);
    vm.runtime.requestAddMonitor(MonitorRecord(data.data.monitor));
};

export const onMonitorUpdated = (data) => {
    setLocalFlag(true);
    vm.runtime.requestUpdateMonitor(Map(data.data.monitor));
};

export const onSliderValueChanged = (data) => {
    const { targetId, variableId, value } = data.data;
    const target = targetId
        ? vm.runtime.getTargetById(targetId)
        : vm.runtime.getTargetForStage();
    const variable = target?.variables?.[variableId];
    if (!variable) return false;

    variable.value = value;

    // Only refreshes the cached display value for this monitor (a local
    // call, not routed through the broadcasting override — "value" isn't
    // one of the fields that override treats as structural, so this can't
    // cause a rebroadcast loop) so the slider/number on this client's
    // screen actually moves to match
    vm.runtime.requestUpdateMonitor(Map({ id: variableId, value }));
    return true;
};
